import { classNames } from 'lib/utilities'
import React from 'react'
import Highlighter from 'react-highlight-words'
import { Table } from 'semantic-ui-react'

export default class SortableCell extends React.Component {
  render() {
    const {
      highlight,
      name,
      sort,
      text,
      children,
      textAlign,
      className,
      width,
      ...rest
    } = this.props
    return (
      <Table.Cell
        {...rest}
        width={width}
        className={classNames([className, sort === name && 'selected'])}
        textAlign={textAlign}>
        {!text && children}
        {!children &&
          text &&
          (highlight ? (
            <Highlighter
              highlightClassName="highlight"
              searchWords={[highlight]}
              textToHighlight={text}
              aciveIndex={-1}
            />
          ) : (
            text
          ))}
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Helpers/SortableCell.jsx